  <h2 mat-dialog-title>
    <h3>Financial Assessment — Adams, Mary</h3>
    <button mat-icon-button (click)="closeDialog()" >
      <mat-icon>close</mat-icon>
    </button>
    
  </h2>

  <mat-dialog-content>
 <div class="popup-container"> 

  <div class="popup-body">
    <div class="tab-section">
      <button class="tab active">Resident</button>
      <button class="tab">Spouse</button>
    </div>

    <div class="popup-content">
      <!-- Left column -->
      <div class="left-column">
        <div class="section-header">
          <h4>Income</h4>
          <button class="add-btn">+ Add Income</button>
        </div>

        <div class="item">
          <div class="item-title">Social Security (SSI)</div>
          <div class="item-amount">$1,850</div>
          <div class="item-note">Monthly • Verified</div>
        </div>

        <div class="item">
          <div class="item-title">VA Pension</div>
          <div class="item-amount">$1,390</div>
          <div class="item-note">Monthly • Pending Verification</div>
        </div>

        <div class="section-header">
          <h4>Assets</h4>
          <button class="add-btn">+ Add Asset</button>
        </div>

        <div class="item">
          <div class="item-title">Checking Account</div>
          <div class="item-amount">$1,750</div>
          <div class="item-note">Bank of America • Countable</div>
        </div>

        <div class="item">
          <div class="item-title">Primary Residence</div>
          <div class="item-amount">$12,000</div>
          <div class="item-note">Owner: 100%</div>
        </div>

        <!-- ✅ Added Allowable Expenses Section -->
  <div class="section-header">
    <h4>Allowable Expenses</h4>
  </div>

  <div class="item">
    <div class="item-title">Medicare Part B Premium</div>
    <div class="item-amount">$164.90</div>
  </div>

  <div class="item">
    <div class="item-title">Personal Needs Allowance</div>
    <div class="item-amount">$75.00</div>
  </div>

  <div class="item">
    <div class="item-title">Spouse Allowance</div>
    <div class="item-amount">$400.00</div>
  </div>

      </div>

      
      <!-- Right column -->
       <div class="right-column">
        <div class="eligibility-chip">✅ Eligible for Medicaid</div>

        <div class="summary-card">
          <div class="section">
            <h4>Income & Liability</h4>
            <div class="data-row">
              <span class="label">Gross Income</span>
              <span class="value">$3,240</span>
            </div>
            <div class="data-row negative">
              <span class="label">Allowable Deductions</span>
              <span class="value">- $640</span>
            </div>
            <div class="data-row positive highlight">
              <span class="label">Net Income</span>
              <span class="value">$2,600</span>
            </div>
            <div class="data-row">
              <span class="label">Est. Patient Liability</span>
              <span class="value">$1,950</span>
            </div>
          </div>

          <div class="section">
            <h4>Assets</h4>
            <div class="data-row">
              <span class="label">Countable Assets</span>
              <span class="value">$1,750</span>
            </div>
            <div class="data-row">
              <span class="label">Exempt Assets</span>
              <span class="value">$12,000</span>
            </div>
            <div class="data-row">
              <span class="label">Resource Limit</span>
              <span class="value">$2,000</span>
            </div>
            <div class="data-row highlight">
              <span class="label">Spenddown Needed</span>
              <span class="value">$0</span>
            </div>
          </div>

          <div class="section">
            <h4>Flags</h4>
            <div class="flag verified">MMIS Verified</div>
            <div class="flag pending">Bank Stmts Pending</div>
          </div>

          <div class="button-group">
            <button class="save-btn">Save & Recalculate</button>
            <button class="export-btn">Export Summary PDF ▼</button>
          </div>
        </div>
      </div> 
   
    </div>
  </div>
</div>


 
  </mat-dialog-content>
  




  

  




